<app-card
  class="link"
  style="--spacing: 1rem"
  [routerLink]="getDeviceDetailRoute(device)"
>
  <div>
    @if (device.value) {
      <div class="flex mb-1">
        <app-icon [size]="IconSize.SM" [name]="device.type | icons" />
        <p class="large">
          {{
            device.valueUnit === DeviceValueUnit.PERCENT
              ? (Number(device.value) / 100 | localizedPercent)
              : (device.value | localizedNumber)
          }}
          {{
            device.valueUnit
              ? (LabelConverter.getDeviceValueUnitLabel(device.valueUnit, false)
                | translate)
              : ""
          }}
        </p>
      </div>
    }
    <div class="flex-1">
      <p class="truncate">
        {{ device.lastSeenDate | relativeDate }}
      </p>
      <h4 class="line-clamp">{{ device.name }}</h4>
    </div>
  </div>
</app-card>
